<template>
    <div class="detail">
        <detail-progress
                :progressData="progressData"
                :isFinish="isFinish"
                @cancelCheck="cancelCheck()"
                @backIndex="backIndex()">
        </detail-progress>

        <list></list>

        <detail-index :isFinish="isFinish"></detail-index>

        <report-pdf v-if="showReport"></report-pdf>

        <!-- PK -->
        <transition name="pk-transition"
                    enter-active-class="animated xw-duration slideInUp"
                    leave-active-class="animated xw-duration slideOutDown">
            <xw-pk v-if="pkVisible" :from-url="url"></xw-pk>
        </transition>
        <div class="progress-not" v-if="progress===14&&!user.phone">

                <img src="../../content/images/check/check-icon.png"/>
                <p class="progress-not-p1">登录/注册即可完成诊断</p>
                <p class="progress-not-p2">登录后不仅可以查看网站营销力的问题，还能够使用其他营销工具、在线学习、考试系统或前往福利中心领取福利</p>
            <el-button type="primary" class="progress-not-btn" @click="handleLogin()">登录/注册</el-button>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapActions } from 'vuex'
    import _ from 'lodash'
    import score from './Score'
    import detailProgress from './DetailProgress'
    import list from './List'
    import detailIndex from './DetailIndex'
    import reportPdf from './ReportPDF'
    import xwPk from './PK'
    import util from '../../store/utils'
	export default {
        components: {
            score,
            detailProgress,
            list,
            detailIndex,
            reportPdf,
            xwPk
        },
		data () {
			return {
				url: '',
                time:null,
                progress:0
            }
		},
        watch: {
            loginStep (val){
                console.log(val,util.runAuth('get'),5555)
                if(val!=='login'&&util.runAuth('get')){
                    this.init();
                }if(val!=='login'&&!util.runAuth('get')){
                    // this.$router.push({name: 'index'});
                }
            }
        },
        computed: {
            ...mapState('check', ['token', 'isFinish', 'progressData', 'showReport', 'pkVisible']),
            ...mapState(['user','loginStep']),

        },
        beforeRouteLeave (to, from, next) {
            if (to.name !== 'relogin' && !to.params.isCancel && !this.isFinish) {
                this.beforeCancel({
                    title: '目前正在诊断确认退出吗？',
                    confirmText: '确认',
                    cancelText: '留下'
                }).then(() => {
                    clearInterval(this.time)
                    next();
                })
            } else {
                next();
            }
        },
        created () {
	        this.url = this.$route.query.url;
	        if (!this.url) {
		        this.$notify.error({
			        title: '错误',
			        message: '请返回主页填写需要诊断的网址'
		        });
		        return false;
	        }
	        this.getClassify()
        },
        async mounted () {
            if(!this.$route.params.token){
                let progress=5;
              this.time=setInterval(async ()=>{
                    this.setProgressData({data:[],progress:progress+=3,score:100,subTitle:'尚未发现问题，请耐心等待检测完成'});
                  if(progress==14){
                      clearInterval(this.time)
                      this.progress=progress;
                  }
                },1000)

            }
            else{
                this.init();
            }
        },

        methods: {
            ...mapMutations('check', ['setFinish','setProgressData']),
            ...mapActions('check', ['start', 'getProgress', 'getList', 'cancel', 'getClassify']),
            ...mapActions(['verifyStepLogin']),
            handleLogin (){
                this.verifyStepLogin();
            },
            async init (){
                try {
                    if (!this.token) {
                        await this.start({token: this.$route.params.token,url:this.url});
                    }

                    if (this.isFinish) {
                        this.getList();
                    } else {
                        this.getProgressData();
                    }
                } catch (err) {
                    this.$notify.error({
                        title: '错误',
                        message: err
                    });
                    this.backIndex();
                }
            },
            errorFun (error) {
                console.error('数据异常错误', error);
                this.$confirm('当前网络环境访问异常，请您检查网络环境并重新诊断。', '错误', {
                    confirmButtonText: '返回主页',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    this.cancel();
                    this.backIndex();
                });
            },
		    //获取进度
	        getProgressData () {
	            if (this.isFinish) return;
	        	this.getProgress().then(data => {
	        	    if (!data) {
                        this.errorFun('对象数据异常');
                        return;
                    }
			        if (data.isError) {
                        this.$confirm('当前网站无法访问或已被取消，请确认后重试', '提示', {
                            customClass: 'sys-hint',
                            confirmButtonText: '返回主页',
                            cancelButtonText: '取消',
                        }).then(() => {
                            this.backIndex();
                        }).catch(() => {
                            this.getList();
                        });
                    } else if (data.progress && data.progress === 100) {
                        this.getList();
			        } else {
				        setTimeout(() => {
                            this.getProgressData();
                        }, 3000);
			        }
                }, error => {
                    this.errorFun(error);
                });
	        },
            //取消前的警告窗口
            beforeCancel (content) {
                //用于区分主动和被动触发的取消
                content = content || {
                    title: '检测正在进行中，是否取消？',
                    confirmText: '确定',
                    cancelText: '取消'
                };

                return new Promise((resolve, reject) => {
                    this.$msgbox({
                        title: '提示',
                        message: content.title,
                        showCancelButton: true,
                        confirmButtonText: content.confirmText,
                        cancelButtonText: content.cancelText,
                        beforeClose: (action, instance, done) => {
                            if (action === 'confirm') {
                                instance.confirmButtonLoading = true;
                                instance.confirmButtonText = '正在取消...';
                                this.cancel().then(message => {
                                    this.$message(message);
                                    done();
                                    instance.confirmButtonLoading = false;
                                }, error => {
                                    this.errorFun(error);
                                });
                            } else {
                                done();
                            }
                        }
                    }).then(action => {
                        if (action === 'confirm') {
                            resolve();
                        } else {
                            reject();
                        }
                    })
                })
            },
            //取消检测
            cancelCheck () {
                this.beforeCancel().then(res => {
                    this.backIndex();
                })
            },
            //返回主页
            backIndex () {
                this.$router.push({ name: 'index', params: { isCancel: true } });
            }
        }
	}
</script>

<style lang="scss" scoped>
    .detail {

    }
    .progress-text {
        opacity: .5;
        position: fixed;
        right: 0;
        bottom: 0;
        font-size: 12px;
        padding: 0 5px;
        color: #fff;
        background-color: #2573e8;
    }
    .progress-not {
        position: absolute;
        top: 0;
        left: 50%;
        height: 100%;
        padding-top: 205px;
        margin-left: -10rem;
        background-color: #fff;
        width: 20rem;
        text-align: center;
        font-size: 0.8rem;
        img{
            width: 10.95rem;
            margin-top: 2rem;
        }
        .progress-not-p1{
            font-size: 1.2rem;
            color: #666;
        }
        .progress-not-btn{
            margin-top: 0.5rem;
            width: 15rem;
            line-height: 1rem;
        }
    }
</style>



// WEBPACK FOOTER //
// app/view/detail/Detail.vue